import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VoiceAuditionItem } from '@voice/utils/types';

interface VoicesState {
  youMayAlsoLikeMatches: VoiceAuditionItem[];
  youMayAlsoLikeReason?: string;
  topMatchesReason?: string;
  auditionError: boolean;
  topMatches: VoiceAuditionItem[];
  sampleTextContentModError: boolean;
  sampleText: string;
  userSampleText: string;
}

const initialState: VoicesState = {
  topMatchesReason: undefined,
  topMatches: [],
  auditionError: false,
  youMayAlsoLikeMatches: [],
  youMayAlsoLikeReason: undefined,
  sampleTextContentModError: false,
  sampleText: '',
  userSampleText: '',
};

const voicesSlice = createSlice({
  name: 'voices',
  initialState,
  reducers: {
    setAuditionError: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        auditionError: action.payload,
      };
    },
    setTopMatches: (state, action: PayloadAction<VoiceAuditionItem[]>) => {
      return {
        ...state,
        topMatches: action.payload,
      };
    },
    setTopMatchesReason: (state, action: PayloadAction<string | undefined>) => {
      return {
        ...state,
        topMatchesReason: action.payload,
      };
    },
    setYouMayAlsoLikeMatches: (
      state,
      action: PayloadAction<VoiceAuditionItem[]>
    ) => {
      return {
        ...state,
        youMayAlsoLikeMatches: action.payload,
      };
    },
    setYouMayAlsoLikeReason: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      return {
        ...state,
        youMayAlsoLikeReason: action.payload,
      };
    },
    setSampleText: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        sampleText: action.payload,
      };
    },
    setSampleTextContentModError: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        sampleTextContentModError: action.payload,
      };
    },
    setUserSampleText: (state, action: PayloadAction<string>) => {
      return {
        ...state,
        userSampleText: action.payload,
      };
    },
  },
});

export const {
  setYouMayAlsoLikeMatches,
  setYouMayAlsoLikeReason,
  setTopMatches,
  setAuditionError,
  setTopMatchesReason,
  setSampleText,
  setSampleTextContentModError,
  setUserSampleText,
} = voicesSlice.actions;

export default voicesSlice;
